import {useEffect} from 'react'
import {Navigate, Routes} from 'react-router-dom'
import { useAppDispatch } from '../../store/Store'
import { signOut } from '../Auth.slice'

export function SignOut() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    const logout = async () => {
      dispatch(signOut())
    }

    logout()
    document.location.reload()
  }, [])

  return (
    <Routes>
      <Navigate to='/auth/sign-in' />
    </Routes>
  )
}
